import { useState, useEffect } from "react";
import { api } from "../../lib/api";
import { AIChat } from "../../components/shared/AIChat";
import { Sparkles, CircleDot } from "lucide-react";

export default function AIOps() {
  const [modules, setModules] = useState([]);
  useEffect(() => { api.get("/ai/modules").then((r) => setModules(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="ops-ai-page">
      <div className="mb-6">
        <p className="overline-cc">Intelligence Layer</p>
        <h1 className="page-title mt-1.5">AI Operations Assistant</h1>
      </div>
      <div className="grid lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 rounded-xl border bg-card flex flex-col h-[620px]">
          <div className="px-5 py-4 border-b flex items-center gap-2">
            <Sparkles className="w-4 h-4 text-[var(--cc-accent)]" />
            <h2 className="font-heading font-semibold text-sm">Command Interface</h2>
            <span className="ml-auto overline-cc">GPT-5.4 · Live Business Context</span>
          </div>
          <AIChat mode="admin" className="flex-1 min-h-0"
            placeholder="Ask for insights, quote estimates, dispatch advice..."
            quickActions={[
              { label: "Quote this job", prompt: "I need to quote a job. Ask me the key questions (service, size, distance, stairs, special items) one at a time, then give me a recommended flat rate with a breakdown." },
              { label: "Flag a problem", prompt: "I need to flag an operational problem. Ask me what happened, then give me a triage plan with next actions." },
              { label: "Optimize today's routes", prompt: "Look at today's missions and crew availability from your snapshot and recommend the most efficient dispatch order and crew assignments." },
              { label: "Daily numbers", prompt: "Give me today's business snapshot: pipeline, missions in progress, open invoices, and crew availability — with your top recommendation." },
            ]}
            intro="Operations assistant online. I have live visibility into your pipeline, missions, invoices, and crew availability. Ask me for business insights, a quote estimate, or scheduling guidance — or attach photos of a job for sizing." />
        </div>
        <div className="space-y-3 overflow-y-auto max-h-[620px] pr-1">
          {modules.map((m) => (
            <div key={m.id} data-testid={`ai-module-${m.id}`} className="rounded-xl border bg-card p-5 card-lift">
              <div className="flex items-center justify-between gap-3">
                <h3 className="font-heading font-semibold text-sm">{m.name}</h3>
                <span className={`flex items-center gap-1.5 font-mono-cc text-[10px] uppercase tracking-wider ${m.status === "online" ? "text-emerald-500" : "text-amber-500"}`}>
                  <CircleDot className="w-3 h-3" /> {m.status.replace(/_/g, " ")}
                </span>
              </div>
              <p className="text-xs text-muted-foreground mt-2 leading-relaxed">{m.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
